import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Button,
  Checkbox,
} from "@mui/material";
import React, { useState } from "react";
import { useAnnouncements } from "./AnnoucementsContext";
import { AnnouncementModel } from "./utils";
import ReorderDialog from "./ReorderDialog";

const AnnouncementFilter = () => {
  const {
    pageLoading,
    setPageLoading,
    filters,
    filterValues,
    setFilters,
    announcements,
    setAnnouncements,
    setAnnouncement,
    highPriorityAnnouncements,
    setHighPriorityAnnouncements,
    setReload,
    setViewAllLogs,
  } = useAnnouncements();
  const [showHighPriority, setShowHighPriority] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const openDialog = () => setDialogOpen(true);
  const closeDialog = () => setDialogOpen(false);

  const handleReorderComplete = (newOrder) => {
    setAnnouncements(newOrder);
  };

  const handleFilterChange = (e) => {
    const name = e.target.name.toLowerCase();
    const value = e.target.value;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setAnnouncements(null);
    setPageLoading(true);
  };

  const handleIncludeExpiredFilterChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;
    setFilters((prev) => ({ ...prev, [name]: checked }));
  };

  if (
    filterValues.states !== null &&
    filterValues.agencies !== null &&
    filterValues.priorities !== null &&
    filterValues.roadways !== null &&
    filterValues.type !== null
  )
    return (
      <Box>
        <Typography variant="h5" sx={{ mb: 2, textAlign: "center", mt: 2 }}>
          Manage Announcements
        </Typography>
        <Grid>
          <Grid container spacing={{ xs: 1 }} justifyContent={"space-between"}>
            <Grid alignItems={"stretch"}>
              <FormControl
                sx={{ width: "20ch", marginLeft: 2, marginBottom: 5 }}
              >
                <InputLabel id="FilterAnnouncementsState-label">
                  State
                </InputLabel>
                <Select
                  labelId="FilterAnnouncementsState-label"
                  id="state-selection"
                  value={filters.state}
                  label="State"
                  onChange={handleFilterChange}
                  name="State"
                  disabled={pageLoading}
                >
                  <MenuItem value="all" key="all">
                    -all-
                  </MenuItem>
                  {filterValues.states.map((eachState) => (
                    <MenuItem value={eachState} key={eachState}>
                      {eachState}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                sx={{ width: "20ch", marginLeft: 2, marginBottom: 5 }}
              >
                <InputLabel id="FilterAnnouncementsRoadway-label">
                  Roadway
                </InputLabel>
                <Select
                  labelId="FilterAnnouncementsRoadway-label"
                  id="Roadway-selection"
                  value={filters.roadway}
                  label="Roadway"
                  onChange={handleFilterChange}
                  name="Roadway"
                  disabled={pageLoading}
                >
                  <MenuItem value="all" key="all">
                    -all-
                  </MenuItem>
                  {filterValues.roadways.map((eachroadway) => (
                    <MenuItem value={eachroadway} key={eachroadway}>
                      {eachroadway}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* <FormControl sx={{ width: "20ch", marginLeft: 2, marginBottom: 5 }}>
              <InputLabel id="FilterAnnouncementsAgency-label">
                Agency
              </InputLabel>
              <Select
                labelId="FilterAnnouncementsAgency-label"
                id="agency-selection"
                value={filters.agency}
                label="Agency"
                onChange={handleFilterChange}
                name="Agency"
              >
                <MenuItem value="all" key="all">
                  -all-
                </MenuItem>
                {filterValues.agencies.map((eachagency) => (
                  <MenuItem value={eachagency} key={eachagency}>
                    {eachagency}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
              {/* <FormControl sx={{ width: "20ch", marginLeft: 2, marginBottom: 5 }}>
              <InputLabel id="FilterAnnouncementsPriority-label">
                Priority
              </InputLabel>
              <Select
                labelId="FilterAnnouncementsPriority-label"
                id="Priority-selection"
                value={filters.priority}
                label="Priority"
                onChange={handleFilterChange}
                name="Priority"
              >
                <MenuItem value="all" key="all">
                  -all-
                </MenuItem>
                {filterValues.priorities.map((eachpriority) => (
                  <MenuItem value={eachpriority} key={eachpriority}>
                    {eachpriority}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
              <FormControl
                sx={{ width: "20ch", marginLeft: 2, marginBottom: 5 }}
              >
                <InputLabel id="FilterAnnouncementsType-label">Type</InputLabel>
                <Select
                  labelId="FilterAnnouncementsType-label"
                  id="Type-selection"
                  value={filters.type}
                  label="Type"
                  onChange={handleFilterChange}
                  name="Type"
                  disabled={pageLoading}
                >
                  <MenuItem value="all" key="all">
                    -all-
                  </MenuItem>
                  {filterValues.type.map((eachType) => (
                    <MenuItem value={eachType} key={eachType}>
                      {eachType}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ marginLeft: 2, marginTop: 2 }}>
                <Typography id="FilterAnnouncementsType-label">
                  Include Expired
                </Typography>
                <Checkbox
                  sx={{ marginLeft: 14, marginTop: -4 }}
                  labelId="includeExpired-label"
                  id="includeExpired-selection"
                  checked={filters.includeExpired}
                  label="includeExpired"
                  onChange={handleIncludeExpiredFilterChange}
                  name="includeExpired"
                  disabled={pageLoading}
                />
              </FormControl>
            </Grid>

            {/* <FormControl sx={{marginLeft: 2, marginTop:2 }}>
              <Typography id="FilterAnnouncementsType-label">
                High Priority Announcements
              </Typography>
              <Checkbox
                sx={{ marginLeft:26, marginTop:-4}} 
                labelId="highPriority-label"
                id="highPriority-selection"
                checked={filters.highPriority}
                label="highPriority"
                onChange={handleHighPriorityChange}
                name="highPriority"
                disabled={pageLoading}
              />    
            </FormControl> */}
            <Grid>
              {/* <Box gap={1} display="flex" sx={{ mt:1, justifyContent:"center" }}> */}
              <FormControl sx={{ pr: 1 }}>
                <Button
                  variant="contained"
                  onClick={(e) =>
                    setAnnouncement({ ...AnnouncementModel, eventIds: [] })
                  }
                >
                  Create New Announcement
                </Button>
              </FormControl>
              <FormControl sx={{ pr: 1 }}>
                <Button onClick={openDialog} variant="contained">
                  Reorder High Priority
                </Button>
                <ReorderDialog
                  open={dialogOpen}
                  onClose={closeDialog}
                  highPriorityAnnouncements={highPriorityAnnouncements}
                  onReorderComplete={handleReorderComplete}
                />
              </FormControl>
              <FormControl sx={{ pr: 1 }}>
                <Button
                  variant="contained"
                  onClick={(e) => setViewAllLogs(true)}
                >
                  View All Logs
                </Button>
              </FormControl>
              {/* </Box> */}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
};

export default AnnouncementFilter;
